export class AppraisalFeePricingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAppraisalFeePricings(params) {
    return this.#http.get('/api/appraisal-fee-pricing', { params });
  }

  async getAppraisalFeePricing({ id }) {
    return this.#http.get(`/api/appraisal-fee-pricing/${id}`);
  }

  async createAppraisalFeePricing(body) {
    return this.#http.post('/api/appraisal-fee-pricing', body);
  }

  async updateAppraisalFeePricing({ id, ...body }) {
    return this.#http.put(`/api/appraisal-fee-pricing/${id}`, body);
  }

  async deleteAppraisalFeePricing({ id }) {
    return this.#http.delete(`/api/appraisal-fee-pricing/${id}`);
  }
}
